<template>
  <div v-if="!isDataMissing" class="top page-section">
    <h1 class="top-subtitle">
      Money available
    </h1>
    <h1 class="top-title">
      <span>£</span>{{ numberToHumanReadable(totalInvestable) }}
    </h1>
    <div class="subtitle">
      Based on your account balance and average monthly net balance,
      this is what you might afford to top-up your account.
    </div>
    <button
      class="green-button"
      @click="navigateToEtoro"
    >
      Put this cash to work <span class="arrow-right">→</span>
    </button>
  </div>
  <div v-else class="top page-section">
    <h1 class="top-no-data-title">
      Your last 5
      <br>
      months'
      <br>
      <b>summary</b>
    </h1>
    <div class="subtitle">
      Here is a cashflow summary based on your income and spending from the last 5 months.
    </div>
  </div>
</template>

<script setup>
import { numberToHumanReadable } from '../../../../utils/miscUtils';

const props = defineProps({
  totalInvestable: {
    type: Number,
    required: true,
  },
  isDataMissing: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['navigateToEtoro']);

const navigateToEtoro = () => {
  emit('navigateToEtoro');
};
</script>

<style scoped>
.page-section {
  color: white;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding-bottom: 20px;
}

.top {
  background-color: #F6F8ED;
  padding-bottom: 30px;
}

.top span {
  font-size: 20px;
  font-family: CircularStdBook;
}

.top .green-button {
  background-color: #13C636;
  box-shadow: 0px 4px 21px rgb(20 169 49 / 56%);
  color: white;
  width: 90%;
  margin-top: 50px;
}

.arrow-right {
  margin-left: 10px;
  font-family: CircularStdBook;
}

.top-subtitle {
  font-size: 20px;
  font-family: CircularStdBook;
  padding-top: 60px;
  margin-bottom: 20px;
  color: #205441;
  text-align: left;
  width: 90%;
  margin-left: 5%;
}

.top-title {
  font-size: 67px;
  font-family: CircularStd;
  line-height: 1;
  color: #13C636;
  width: 90%;
  margin-left: 5%;
  text-align: left;
  margin-bottom: 20px;
}

.top-no-data-title {
  font-size: 48px;
  font-family: CircularStdBook;
  color: #13C636;
  padding-top: 60px;
  padding-right: 25px;
  margin-bottom: 20px;
  text-align: left;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  font-weight: 100 !important;
  line-height: 1;
}

.top-no-data-title b {
  font-weight: 700 !important;
}

.subtitle {
  font-size: 18px;
  color: #205441;
  font-family: CircularStdBook;
  width: 90%;
  margin-left: 5%;
}

.green-button {
  background-color: #205441;
  box-shadow: 0px 4px 21px rgba(149.13, 152.94, 149.88, 0.56);
  border-radius: 12px;
  color: white;
  padding: 17px 0px;
  border: none;
  width: 90%;
  cursor: pointer;
  font-size: 18px;
  font-family: CircularStdBook;
  font-weight: 700;
  margin: 20px auto;
  display: block;
}
</style>
